import React, {Component} from 'react';
import _ from 'lodash';

export default class RenderFileNames extends Component {
  constructor(props){
    super(props)

    this.renderFile = this.renderFile.bind(this);
  }

  renderFile(file, index){
    if (_.isEmpty(file.file_name)) { return }
    return (
      <div key={index} className='col-md-12 text-overflow' style={{position: 'relative'}}>
        <i onClick={()=>this.props.onDeleteFile(index)}
            className="fa fa-times top-right pointer" 
            aria-hidden="true">
          </i>
        {file.file_name}
      </div>
    )
  }

  render(){
    return (
      <div className='row'>
        {this.props.files && _.map(this.props.files, this.renderFile)}
        </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/RenderFileNames.js